import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Box, useTheme } from '@mui/material';
import { IconButton, IconButtonProps } from 'components/IconButton';

interface PropsType {
	onClick?: () => Promise<void>;
	size?: IconButtonProps['size'];
}

const fontSize = {
	small: '16px',
	medium: '24px',
	large: '32px',
} as const;

function DeleteButton({ onClick, size = 'small' }: PropsType) {
	const theme = useTheme();
	return onClick ? (
		<IconButton color="error" onClick={onClick}>
			<DeleteIcon />
		</IconButton>
	) : (
		<Box
			sx={{
				padding: '8px',
				background: theme.palette.error.main,
				color: theme.palette.error.contrastText,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: '10px',
			}}
		>
			<DeleteIcon
				sx={{
					fontSize: fontSize[size],
				}}
			/>
		</Box>
	);
}

export default DeleteButton;
